module.exports = __webpack_public_path__ + "img/power.8ff9fcb1.png";